export const PostBoxFooter = ({ children }) => {
  return <>{children}</>;
};
